export const locale = {
  lang: "fr-CA",
  data: {
    UPSALE_QUESTIONS_PANEL: {
      TITLE: "Vente incitative",
      SEARCH: "Rechercher une question",
      LEFT_LIST_LABEL:
        "Glisser et déposer ou utiliser le bouton + pour ajouter des questions",
      RIGHT_LIST_LABEL: "Liste des questions à ajouter",
      NO_RESULTS: "Aucun résultat",
      NO_ATTACHED: "Aucune question attachée à ce produit.",
      CREATE_QUESTION: "Créer une question",
    },
  },
};
